import { Component, OnInit } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { ContextInteractionService } from '../../services/context-interaction.service';


@Component({
    selector: 'app-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    standalone: false
})
export class ListComponent extends BaseControlComponent implements OnInit {
    static componentName = 'ListComponent';

    heroes = ['Captain America', 'Thor', 'Hulk', 'Batman', 'Superman'];
    myHero = this.heroes[0];

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    ngOnInit() {

    }
}